/* eslint-disable no-unused-vars */
import { useRef, useEffect } from 'react';
import { useFloating, flip, offset, FloatingArrow, arrow, autoUpdate } from '@floating-ui/react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import * as S from './FloatingPopUp.styled';
import { createPortal } from 'react-dom';

const Z_INDEX = 9000;

export const FloatingPopUp = ({
  customZIndex = Z_INDEX,
  triggerComponent,
  popUpComponent,
  isOpen,
  defaultPlacement = 'top',
  popUpWrapStyle = {},
  triggerStyle = {},
  closeAction,
  sliceStyle = {},
  offsetValue = 0,
  arrowStyle = {},
  isArrow = false,
  animationParentStyle = {},
  durationValue = 100,
  isOverlay = true,
}) => {
  const [animationParent] = useAutoAnimate({ duration: durationValue });
  const arrowRef = useRef(null);
  const overlayContainer = useRef(document.createElement('div'));
  const { x, y, strategy, refs, context } = useFloating({
    open: isOpen,
    middleware: [
      flip(),
      offset(offsetValue),
      arrow({
        element: arrowRef,
      }),
    ],
    placement: defaultPlacement,
    whileElementsMounted: autoUpdate,
  });

  useEffect(() => {
    const controller = new AbortController();
    if (isOpen) {
      window.addEventListener('scroll', closeAction, {
        once: true,
        signal: controller.signal,
      });
    }
    return () => {
      // window.removeEventListener('scroll', closeAction, { capture: true, once: true });
      controller.abort();
    };
  }, [isOpen, closeAction]);

  useEffect(() => {
    if (isOverlay) document.body.appendChild(overlayContainer.current);
    return () => {
      if (isOverlay) document.body.removeChild(overlayContainer.current);
    };
  }, []);

  return (
    <>
      <div>
        <div
          style={{
            position: 'relative',
            zIndex: isOpen ? customZIndex + 1 : 0,
            ...triggerStyle,
          }}
          ref={refs.setReference}
        >
          {triggerComponent}
        </div>
        {isOpen &&
          createPortal(
            <S.Slice style={{ ...sliceStyle }} onClick={closeAction} />,
            overlayContainer.current,
          )}
        <div
          ref={animationParent}
          style={{ zIndex: customZIndex, position: 'absolute', ...animationParentStyle }}
        >
          {isOpen && (
            <div
              ref={refs.setFloating}
              style={{
                position: strategy,
                top: y ?? 10,
                left: x ?? 10,
                width: 'max-content',
                zIndex: customZIndex,
                ...popUpWrapStyle,
              }}
            >
              {popUpComponent}
              {isArrow && (
                <FloatingArrow
                  ref={arrowRef}
                  context={context}
                  fill='#fff'
                  style={{ zIndex: customZIndex, ...arrowStyle }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

FloatingPopUp.placements = {
  top: 'top',
  bottom: 'bottom',
  right: 'right',
  left: 'left',
  right_start: 'right-start',
  right_end: 'right-end',
  left_start: 'left-start',
  left_end: 'left-end',
  top_start: 'top-start',
  top_end: 'top-end',
  bottom_start: 'bottom-start',
  bottom_end: 'bottom-end',
};
